import React from 'react';
import { ShieldCheckIcon, CalendarIcon, AlertCircleIcon } from 'lucide-react';
export function Hero() {
  return <section id="start" className="bg-gradient-to-b from-white to-blue-50 py-16 md:py-24" data-id="element-345">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-346">
        <div className="lg:flex lg:items-center lg:justify-between" data-id="element-347">
          <div className="lg:w-1/2" data-id="element-348">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight" data-id="element-349">
              Bereit für die neuen IT-Sicherheitsrichtlinien 2026?
            </h1>
            <h2 className="mt-2 text-2xl md:text-3xl font-semibold text-blue-600" data-id="element-350">
              Wir machen Ihre Praxis §390-ready!
            </h2>
            <p className="mt-6 text-lg text-gray-700 max-w-2xl" data-id="element-351">
              Ab 1. Januar 2026 gelten neue, verbindliche IT-Sicherheitsvorgaben
              für Zahnarztpraxen. Wir prüfen Ihre Systeme und setzen alle
              Maßnahmen um – damit Sie rechtzeitig sicher sind.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4" data-id="element-352">
              <a href="#kontakt" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-353">
                Kostenlose Erstberatung sichern
              </a>
              <a href="#änderungen" className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-354">
                Was ändert sich?
              </a>
            </div>
          </div>
          <div className="mt-12 lg:mt-0 lg:w-1/2" data-id="element-355">
            <div className="bg-white rounded-lg shadow-xl overflow-hidden" data-id="element-356">
              <div className="px-6 py-8" data-id="element-357">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-358">
                  Wichtige Fristen:
                </h3>
                <ul className="mt-4 space-y-4" data-id="element-359">
                  <li className="flex" data-id="element-360">
                    <CalendarIcon className="h-6 w-6 text-blue-500 flex-shrink-0" data-id="element-361" />
                    <span className="ml-3 text-gray-700" data-id="element-362">
                      <span className="font-medium" data-id="element-363">Juli 2025:</span>{' '}
                      Veröffentlichung der neuen Richtlinien
                    </span>
                  </li>
                  <li className="flex" data-id="element-364">
                    <AlertCircleIcon className="h-6 w-6 text-red-500 flex-shrink-0" data-id="element-365" />
                    <span className="ml-3 text-gray-700" data-id="element-366">
                      <span className="font-medium" data-id="element-367">1. Januar 2026:</span>{' '}
                      Pflicht zur Umsetzung
                    </span>
                  </li>
                  <li className="flex" data-id="element-368">
                    <ShieldCheckIcon className="h-6 w-6 text-green-500 flex-shrink-0" data-id="element-369" />
                    <span className="ml-3 text-gray-700" data-id="element-370">
                      <span className="font-medium" data-id="element-371">Jetzt handeln:</span>{' '}
                      Vermeiden Sie Stress und Risiken durch rechtzeitige
                      Vorbereitung
                    </span>
                  </li>
                </ul>
              </div>
              <div className="px-6 py-4 bg-blue-50" data-id="element-372">
                <p className="text-sm text-blue-700" data-id="element-373">
                  „§390-Ready mit neocube – IT-Sicherheit, die Ihre Praxis
                  schützt."
                </p>
                <p className="text-sm text-gray-600" data-id="element-374">
                  Wir bringen Ihre Zahnarztpraxis sicher durch die neuen
                  Richtlinien 2026.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}